export const ProductFillFrames = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.9291 10.8866C23.7863 11.3815 23.7863 12.6187 22.9291 13.1135L12.6434 19.052C11.7863 19.5469 10.7148 18.9283 10.7148 17.9385L10.7148 6.06161C10.7148 5.07187 11.7863 4.45328 12.6434 4.94815L22.9291 10.8866Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.857143"
    />
    <path
      d="M13.4994 10.8866C14.3566 11.3815 14.3566 12.6187 13.4994 13.1135L3.21373 19.052C2.35659 19.5469 1.28516 18.9283 1.28516 17.9385L1.28516 6.06161C1.28516 5.07187 2.35659 4.45328 3.21373 4.94815L13.4994 10.8866Z"
      fill="currentColor"
      opacity="0.6"
      stroke="currentColor"
      strokeWidth="0.857143"
    />
  </svg>
);
